<template>
    <b-container fluid class="mt--7 pb-4">
        <b-card title="Role">
            <form @submit.prevent="update()">
                <b-form-group
                    id="name-group"
                    label="Name"
                    label-for="input-name"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>
                <label class="form-control-label mt-3">Permissions</label>
                <permission-groups
                    v-model="model.permissions"
                ></permission-groups>
                <b-row>
                    <b-col>
                        <b-button-group size="sm">
                            <b-button
                                v-if="hasPermissionDelete"
                                @click="deleteRole()"
                                variant="warning"
                                class="float-right"
                            >
                                Delete Role
                            </b-button>
                            <b-button
                                v-if="hasPermissionUpdate"
                                @click="update()"
                                variant="primary"
                                class="float-right"
                                :disabled="updating ? true : false"
                                >{{
                                    updating
                                        ? 'Saving Changes...'
                                        : 'Save Changes'
                                }}</b-button
                            >
                            <b-button
                                :disabled="updating"
                                class="float-right"
                                variant="secondary"
                                @click="cancel()"
                            >
                                Cancel
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            </form>
        </b-card>
    </b-container>
</template>
<script>
//import Multiselect from 'vue-multiselect'
import PermissionGroups from '@/components/PermissionGroups'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import utilityMixins from '@/mixins/utilityMixins'

export default {
    name: 'roles-view',
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    components: { PermissionGroups },
    data() {
        return {
            componentName:'Role',
            model: {
                id: 0,
                name: '',
                permissions: [],
            },
            updating: false,
        }
    },
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        role() {
            return this.$store.state.roles.item || {}
        },
    },
    watch: {
        role: function (val) {
            console.log('role changed', val)
            const model = { ...val }
            model.permissions = model.permissions.map(x => x.permission)
            this.model = model
        },
    },
    methods: {
        cancel() {
            this.$router.push('/admin/roles')
        },
        update() {
            this.updating = true
            this.$validator.validate().then(valid => {
                if (valid) {
                    console.log('update', this.model)
                    this.$store
                        .dispatch('roles/update', this.model)
                        .then(() => {
                            this.genericToast(this.componentName,'Updated','success','Role has been updated successfully')
                            // this.doToast('Role Updated', 'success')
                        })
                        .catch(error => {
                            this.doToast(
                                'Error!',
                                error.response.data.error.message,
                                'Danger'
                            )
                        })
                        .finally(() => {
                            this.updating = false
                        })
                } else {
                    this.updating = false
                }
            })
        },

        deleteRole() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/roles',
                deleteRoute: 'roles/delete',
            }
            const notificationFields = {
                type: 'Role',
                errorMsg: 'Unable to delete role!',
            }

            this.deleteItem(notificationFields, model, routes)
        },
    },
    mounted() {
        this.$store.dispatch('permissions/all')
        this.$store.dispatch('roles/fetchById', this.$route.params.id)
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
